<style lang="less" scoped>
    .input-wrapper{
        display: inline-block;
        vertical-align: middle;
        .ivu-input-wrapper{
            margin-top: -2px;
        }
    }
</style>
<template>
  <div>
    <div class="line text-center">
      <RadioGroup
        v-model="params.status"
        type="button"
        @on-change="doSearch"
      >
        <Radio label="">
          所有状态
        </Radio>
        <Radio label="failed">
          失败的
        </Radio>
        <Radio label="success">
          成功的
        </Radio>
        <Radio label="pending">
          待同步
        </Radio>
        <Radio label="abandon-pending">
          待删除
        </Radio>
        <Radio label="abandon">
          已作废
        </Radio>
      </RadioGroup>
    </div>
    <div class="line text-center">
      <i-input
        v-model="params.search"
        placeholder="管易发货单号"
        style="width: 250px"
        @on-enter="doSearch"
      />
      <space />
      <Ajaxbtn
        ref="searchBtn"
        type="search"
        :url="query_path"
        :params="params"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>
    <Table
      size="small"
      :columns="column"
      :data="out_stocks"
      :loading="loading"
    />
    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <Modal
      v-model="detail_modal"
      width="800"
    >
      <div v-if="loading_detail">
        <Spin
          fix
          size="large"
        />
      </div>
      <div v-else>
        <div class="line text-bold">
          <span>发货单号: {{ cerp_delivery_order.code }}</span>
          <span>发货时间: {{ $util.formatTime(cerp_delivery_order.delivery_date) }}</span>
        </div>
        <div
          class="line text-bold"
          style="white-space: pre-line"
        >
          <span>运费: {{ $util.formatPrice(cerp_delivery_order.post_fee) }}</span>
        </div>
        <div
          v-if="cerp_delivery_order.kingdee_sync_result"
          class="line"
        >
          {{ cerp_delivery_order.kingdee_sync_result }}
        </div>
        <div class="hr" />
        <div class="line text-center">
          管易发货单详情
        </div>
        <table class="mis-table">
          <tr>
            <th>存货编码</th>
            <th>数量</th>
            <th>金额</th>
            <th>金蝶库存</th>
          </tr>
          <tr
            v-for="item in cerp_delivery_items"
            :key="item.id"
          >
            <td>{{ item.item_code }}</td>
            <td>{{ item.qty }}</td>
            <td>{{ $util.formatPrice(item.amount_after) }}</td>
            <td>{{ $util.formatNumber(stock_uid_inventory_hash[item.item_code]) }}</td>
          </tr>
        </table>
      </div>
    </Modal>
  </div>
</template>
<script route="/kingdee_sync/out_stock">
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        query_path: this.$util.api.kingdee_sync_split_out_stock_query,
        params: {
          page: 1,
          status: 'failed',
          search: ''
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        out_stocks: [],
        column: [
          {
            title: '管易发货单号',
            align: 'center',
            width: 120,
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'link': true
                },
                on: {
                  click: () => {
                    this.showOrderDetail(row.id);
                  }
                }
              }, row.code);
            }
          },
          {
            title: '拆单单号',
            align: 'center',
            width: 120,
            key: 'split_code'
          },
          {
            title: '发货时间',
            align: 'center',
            width: 130,
            render: (h, params) => {
              const row = params.row;
              return h('div', row.delivery_date ? this.$util.formatTime(row.delivery_date) : '-');
            }
          },
          {
            title: '店铺名称',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              return h('div', row.shop_name || '-');
            }
          },
          {
            title: '发货仓库',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              return h('div', row.warehouse_name || '-');
            }
          },
          {
            title: '发货已取消',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                class: {
                  'color-error': row.cancel,
                  'color-grey': !row.cancel,
                }
              }, row.cancel ? '已取消' : '否');
            }
          },
          {
            title: '同步结果',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              const row = params.row;
              const render_items = [];
              const sync_status = row.sync_status;
              const sync_succeed = sync_status === 'success';
              const sync_failed = sync_status === 'failed';
              render_items.push(h('div', {
                class: {
                  'color-success': sync_succeed,
                  'color-error': !sync_succeed,
                }
              }, sync_status))
              if (sync_failed) {
                return h('div', {
                  class: {
                    'color-error': true
                  }
                }, row.sync_result);
              }
              return h('div', render_items);
            }
          },
          // {
          //     title: 'action',
          //     align: 'center',
          //     render: (h, params) => {
          //         let row = params.row;
          //         let ret = [];
          //         if(row.status === 0){
          //             ret.push(h('Button', {
          //                 props: {
          //                     size: 'small',
          //                     loading: this.retry_id_hash[row.id]
          //                 },
          //                 on: {
          //                     click: ()=>{
          //                         this.retry(row);
          //                     }
          //                 }
          //             }, '重试'));
          //             ret.push(h('span', ' '));
          //             ret.push(h('Button', {
          //                 props: {
          //                     size: 'small',
          //                     loading: this.force_id_hash[row.id]
          //                 },
          //                 on: {
          //                     click: ()=>{
          //                         this.$Modal.confirm({
          //                             title: '提示',
          //                             content: '你确定要强制设为成功吗?',
          //                             onOk: ()=>{
          //                                 this.forceSuccess(row);
          //                             }
          //                         });
          //                     }
          //                 }
          //             }, '强制成功'));
          //         }
          //         return h('div', ret);
          //     }
          // },
        ],
        loading: false,
        loading_detail: false,
        detail_modal: false,
        cerp_delivery_order: {},
        cerp_delivery_items: [],
        real_time_inventories: []
      }
    },
    computed: {
      stock_uid_inventory_hash() {
        const hash = {};
        this.real_time_inventories.forEach((record) => {
          hash[record.stock_uid] = record.qty;
        })
        return hash;
      },
      ...mapGetters('async', {
        warehouses: 'warehouses'
      }),
    },
    created() {
      //
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      pageChange(page) {
        this.loading = true;
        this.params.page = page;
        this.$refs.searchBtn.doAjax(true);
      },
      beforeSearch() {
        this.params.page = 1;
        this.out_stocks = [];
      },
      doSearch() {
        this.loading = true;
        this.$refs.searchBtn.doAjax();
      },
      handleData(data) {
        this.loading = false;
        this.out_stocks = data.out_stocks;
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.$Modal.error({title: '提示', content: e.message});
      },
      showOrderDetail(order_id) {
        this.loading_detail = true;
        this.cerp_delivery_order = {};
        this.cerp_delivery_items = [];
        this.kingdee_out_stocks = [];
        this.detail_modal = true;
        this.$util.ajax.get(this.$util.api.kingdee_sync_out_stock_detail, {
          params: {
            id: order_id
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.cerp_delivery_order = data.cerp_delivery_order;
            this.cerp_delivery_items = data.cerp_delivery_items;
            this.real_time_inventories = data.real_time_inventories;
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading_detail = false;
        });
      }
    }
  }
</script>
